import { createRoot } from 'react-dom/client'
import React, { Component, useRef, useState } from 'react'
import './styles.css'
import App from './App'

createRoot(document.getElementById('root')).render(
  <App />
)
